import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, take, takeUntil } from 'rxjs';
import { NotificationService } from '../../services/notifications.service';
import { ProfileService } from '../../services/profile.service';
import { Router } from '@angular/router';
import { BaseService } from '../../services/base.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PhoneForm } from './additional-info.interface';
import { activeTranslations, NAME_PROJECT } from '../../enum/constants';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AdditionalInfoComponent implements OnInit, OnDestroy {
  // Class variables declaration
  protected readonly NAME_PROJECT = NAME_PROJECT;

  public phone!: string;

  public validation: boolean = false;
  public focused: boolean = false;
  public isSubmitted: boolean = false;
  public isButtonDisabled: boolean = false;

  public phoneForm!: FormGroup<PhoneForm>;

  // For destroy
  private readonly destroy$ = new Subject<null>();

  constructor(
    private readonly router: Router,
    private readonly profileService: ProfileService,
    private readonly baseService: BaseService,
    private readonly notificationService: NotificationService,
    private readonly authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.baseService
      .getProfile()
      .pipe(takeUntil(this.destroy$))
      .pipe(take(1))
      .subscribe((res) => {
        if (res && res.phone) {
          this.router.navigate(['/companies']);
        }
      });
    const user = this.baseService.currentUserInfo;
    if (user && user.phone) {
      this.router.navigate(['/companies']);
    }
    this.phoneForm = new FormGroup({
      phone: new FormControl('', [Validators.required]),
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  handleClick() {
    this.isButtonDisabled = true;
  }

  isPhoneValid(phone: string) {
    if (!phone) {
      this.validation = true;
      return false;
    }
    if (!phone.startsWith('380')) {
      return this.notificationService.showError(
        activeTranslations.notifications_texts.error.invalid_phone_number_t,
        activeTranslations.notifications_texts.error.invalid_phone_number_m_1,
      );
    } else if (phone.length !== 12) {
      return this.notificationService.showError(
        activeTranslations.notifications_texts.error.invalid_phone_number_t,
        activeTranslations.notifications_texts.error.invalid_phone_number_m_2,
      );
    }
    if (this.validation) this.validation = false;
    return true;
  }

  addPhoneIntoProfile(): void {
    const referral_code = localStorage.getItem('utm_source');
    this.isSubmitted = true;
    if (this.isPhoneValid(this.phoneForm.controls.phone.value)) {
      this.handleClick();
      this.profileService
        .createAdditional({
          phone: this.phoneForm.controls.phone.value,
          referral_code: referral_code,
        })
        .subscribe({
          next: () => {
            this.notificationService.showSuccess(
              '',
              activeTranslations.notifications_texts.success.successfully_added,
            );
            this.router.navigate(['/companies']);
          },
          error: (errors) => {
            this.isButtonDisabled = false;
            if (errors?.error?.errors[0]?.code === 'PHONE_ALREADY_EXISTS') {
              this.notificationService.showError(
                activeTranslations.notifications_texts.error.error,
                activeTranslations.notifications_texts.error.number_already_exists,
              );
              this.phoneForm.controls.phone.setErrors({});
            } else {
              this.notificationService.showError(
                activeTranslations.notifications_texts.error.error,
                activeTranslations.notifications_texts.error.something_went_wrong_2,
              );
              console.log('addPhoneError:', errors);
            }
          },
        });
    }
  }

  goBack() {
    this.authService.logout();
  }
}
